import { createUseStyles } from "react-jss";
import { BORDERS } from "../../../../../constants/styleGuide";

/**
 * styles used in the component.
 */
export const overviewPhaseStyles = createUseStyles({
  dataTableWrap: {
    margin: "0",
    '& table > thead > tr >th': {
      borderTop: "1px solid rgba(224, 224, 224, 1)"
    },
    "& table > thead > tr > th.MuiTableCell-head": {
      color: "#000000",
      fontWeight: "bold",
      borderLeft: BORDERS.WHITE,
      "&:last-child":{
        borderRight: BORDERS.WHITE
      }
    },
    "& table > tbody > tr > td.MuiTableCell-root": {
      color: "#000000",
      borderLeft: BORDERS.WHITE,
      "&:last-child":{
        borderRight: BORDERS.WHITE
      }
    },
    "& table > tbody > tr.MuiTableRow-root.MuiTableRow-hover:hover": {
      cursor: "default",
      background: "#fff"
    },
    "& table > thead > tr > th.MuiTableCell-head button": {
      color: "#000000",
      fontWeight: "bold",
    },
    "& > div > div > div.MuiToolbar-root":{
      display: 'none'
    }
  },
  overviewTitleHead: {
    margin: "0",
    paddingBottom: "16px",
    fontSize: "24",
    lineHeight: "36px",
  },
  overviewTableHeader: {
    display: "contents",
  },
  overviewTableHeaderRow: {
    padding: "16px",
    fontSize: "12px",
    lineHeight: "1.33",
    color: "#2e2f32",
    fontWeight: "bold",
    border: BORDERS.BLUE_GREY,
  },
  overviewHeaderRowRight: {
    textAlign: "right",
    padding: "16px",
    fontSize: "12px",
    lineHeight: "1.33",
    color: "#2e2f32",
    fontWeight: "bold",
    border: BORDERS.BLUE_GREY,
  },
  overviewTableBody: {
    display: "contents",
  },
  overviewTableBodyRow: {
    padding: "16px",
    fontSize: "12px",
    lineHeight: "1.33",
    color: "#2e2f32",
    border: BORDERS.BLUE_GREY,
  },
  overviewBodyRowRight: {
    textAlign: "right",
    padding: "16px",
    fontSize: "12px",
    lineHeight: "1.33",
    color: "#2e2f32",
    border: BORDERS.BLUE_GREY,
  },
  amountStyle:{
    float: "right"
  }
});
